import React from "react";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import Tooltip from "../../uiElements/tooltip/Tooltip";

import withHelpText from "../input/withHelpText";

import "./SelectInput.css";

const defaultStyles = {
  indicatorSeparator: () => ({
    border: "none",
  }),
  container: styls => ({
    ...styls,
    minHeight: "50px",
  }),
  control: styls => ({
    ...styls,
    minHeight: "50px",
    borderRadius: "5px",
    "&:hover": {
      borderColor: "#bbc1d0",
    },
  }),
  option: styls => ({
    ...styls,
    cursor: "pointer",
  }),
  dropdownIndicator: styles => ({
    ...styles,
    cursor: "pointer",
  }),
};

const Control = ({ children, ...props }) => {
  const error = props.selectProps.selectProps.error;
  return (
    <components.Control {...props}>
      <span className="errorContainer">
        <Tooltip id={error} className="errorButton">
          {error}
        </Tooltip>
      </span>
      {children}
    </components.Control>
  );
};

const SelectInput = ({
  label,
  value,
  options,
  onChange,
  placeholder,
  isMulti,
  isSearchable,
  components,
  styles,
  error,
  required,
  isCreateble,
  ...rest
}) => {
  return (
    <>
      {label && (
        <label className="text-left input-label position-absolute">
          {label}
        </label>
      )}
      {required && (
        <span className="text-danger" style={{ marginLeft: 5 }}>
          *
        </span>
      )}

      {isCreateble ? (
        <CreatableSelect
          isMulti={isMulti}
          selectProps={{ error }}
          components={error && { Control }}
          isSearchable={isSearchable}
          styles={{ ...defaultStyles, ...styles }}
          placeholder={placeholder}
          options={options}
          onChange={onChange}
          value={value}
          formatCreateLabel={input => `Add "${input}"`}
          {...rest}
        />
      ) : (
        <Select
          isMulti={isMulti}
          selectProps={{ error }}
          components={error && { Control }}
          isSearchable={isSearchable}
          styles={{ ...defaultStyles, ...styles }}
          placeholder={placeholder}
          options={options}
          onChange={onChange}
          value={value}
          {...rest}
        />
      )}
    </>
  );
};

export default SelectInput;

export const SelectInputWithHelpText = withHelpText(SelectInput);
